import Api from '@/services/Api'

// Router
import router from '@/router/index'

// Vuex
import store from '../store'
import { mapActions } from 'vuex'

class UserApi {

  static isAdmin() {
    return store.getters['user/isAdmin'];
  }

  static isLoggedIn() {
    return store.getters['user/isLoggedIn'];
  }

  static logout() {
    store.dispatch('user/logout').then(() => {
      router.push('/login');
    });
  }

  static getData() {
    return store.dispatch('user/retrieveProfile').then(() => {
      if (store.getters['user/getUser']) {
        return store.getters['user/getUser'];
      }
    });
  }

  static getUser(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api().get(`user/${id}`)
        const data = res.data
        resolve(data)
      } catch (err) {
        console.log(err)
        reject(err)
      }
    })
  }

  static getUserData() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api().get('profile')
        const data = res.data
        resolve(data)
      } catch (err) {
        console.log(err)
        reject(err)
      }
    })
  }

  static getUsers(currentPage, perPage, sortBy, sortDesc, filter, activeOnly, noPermanent) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api().get(`user?page=${currentPage}&limit=${perPage}` + (sortBy ? `&sortBy=${sortBy}&sortDesc=${sortDesc}` : ``) + (filter ? `&filter=${filter}` : ``) + (activeOnly ? `&activeOnly=${activeOnly}` : ``) + (noPermanent ? `&noPermanent=${noPermanent}` : ``))
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static createUser(user) {
    return new Promise(async (resolve, reject) => {
      try {
        // Post data to backend
        const res = await Api().post(`user/`, {
          username: user.username,
          steam_id: user.steam_id,
          discord_id: user.discord_id,
          expiration_date: user.expiration_date,
          permanent: user.permanent,
          plan_id: user.plan_id,
        });

        // Receive data
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static updateUser(user) {
    return new Promise(async (resolve, reject) => {
      try {
        // Post data to backend
        const res = await Api().patch(`user/${user.player_id}`, {
          username: user.username,
          steam_id: user.steam_id,
          discord_id: user.discord_id,
          expiration_date: user.expiration_date,
          permanent: user.permanent,
          remove: user.remove,
          plan: user.plan
        });

        // Receive data
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static getProfile() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api().get('profile/token')
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static getLogin() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api().get('auth')
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static getLogout() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api().get('profile/logout')
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static addDonator(orderID, planID) {
    return new Promise(async (resolve, reject) => {
      try {
        // Get User
        const user = await this.getData();

        // Post data to backend
        const res = await Api().post('profile/donate', {
          user: user,
          order_id: orderID,
          plan_id: planID
        });

        // Receive data
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static getDonations(user) {
    return new Promise(async (resolve, reject) => {
      try {
        // Post data to backend
        const res = await Api().post('profile/donations', {
          user: user
        })

        // Receive data
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }

  static getUserDonations() {
    return new Promise(async (resolve, reject) => {
      try {
        // Get User
        const user = await this.getData();

        // Post data to backend
        const res = await Api().post('profile/donations', {
          user: user
        })

        // Receive data
        const data = res.data
        resolve(data)
      } catch (err) {
        reject(err)
      }
    })
  }
}

export default UserApi



// WEBPACK FOOTER //
// ./src/services/UserApi.js